<template>
  <div>
    <div
      v-if="!isGPCRPage() && !showFilterResults && myList && myList.resources"
      :ref="myList.slug"
      :key="Math.random()"
      class="mt-[40px] w-[calc(100vw-24px)] ml-[24px] lg:ml-0 lg:w-full"
    >
      <h1 class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold">
        {{ myList.name }}
      </h1>
      <ResourcesSlider
        v-if="myList.resources.length > 0"
        :tag-slug="myList.slug"
        :category-index="-1"
        :items="myList.resources"
      />
      <div
        v-else
        class="w-[calc(100%-24px)] max-w-[584px] bg-[#F0F2F4] h-[226px] font-aktiv-grotesk-medium text-[16px] leading-[24px] rounded-[16px] flex flex-col justify-center text-center"
      >
        <p class="w-[189px] mx-auto">
          Start adding to My List <br />
          by tapping the <br />
          <span
            class="bookmark-hint-icon inline-block w-[16px] h-[16px] text-[#99A4B2] align-text-bottom"
            :style="{ '--bookmark-icon': 'url(/assets/icons/bookmark-outline.svg)' }"
            role="img"
            aria-label="bookmark"
          ></span>
          icon on resources
        </p>
      </div>
    </div>

    <div
      v-if="
        !isGPCRPage() &&
        !isGICPage() &&
        !showFilterResults &&
        allWatchLists.length > 0 &&
        allWatchLists[0].resources &&
        allWatchLists[0].resources.length > 0
      "
      class="mt-[40px] w-[calc(100vw-24px)] ml-[24px] lg:ml-0 lg:w-full"
    >
      <h1 class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold">
        {{ allWatchLists[0].name }}
      </h1>
      <ResourcesSlider
        :tag-slug="allWatchLists[0].slug"
        :category-index="-2"
        :items="allWatchLists[0].resources"
        :is-watch-list="true"
      />
    </div>

    <div v-if="!showFilterResults">
      <div
        v-for="(resource, i) in sortedList"
        :key="`${resource.slug}-${resource.resources.map(r => r.slug).join('|')}`"
        :ref="resource.slug"
        class="mt-[40px] w-[calc(100vw-24px)] ml-[24px] lg:ml-0 lg:w-full"
      >
        <h1 class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold">
          {{ resource.name }}
        </h1>
        <ResourcesSlider
          :tag-slug="resource.slug"
          :category-index="i"
          :items="resource.resources"
        />
      </div>
    </div>

    <div
      v-if="!showFilterModal && showFilterResults"
      class="font-aktiv-grotesk flex flex-row ml-[24px] md:mx-[96px] lg:ml-0 relative"
    >
      <FilterResultSection
        :filteredResources="filteredResources"
        :filteredQuotes="[]"
        :filteredBooks="[]"
      />
    </div>

    <div
      v-if="allBooks.length > 0 && !showFilterResults"
      class="mt-[40px] w-[calc(100vw-24px)] ml-[24px] lg:ml-0 lg:w-full"
    >
      <h1 class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold">
        {{ allBooks[0].name }}
      </h1>
      <div class="rounded-[16px] w-[228px] md:w-[262px] md:pr-6 lg:w-[287px]">
        <in-app-browser :href="bookUrl" target="_blank">
          <img
            class="w-full rounded-[16px] cursor-pointer"
            :src="allBooks[0].resources[0].thumbnail"
          />
        </in-app-browser>
      </div>
    </div>
    <!-- <div
      v-if="allQuotes.length > 0"
      class="mt-[40px] w-[calc(100vw-24px)] ml-[24px] pb-[80px] lg:ml-0 lg:w-full bg-[#F8F9F9]"
    >
      <h1
        class="mb-[16px] font-aktiv-grotesk text-[24px] leading-[32px] font-bold"
      >
        {{ allQuotes[0].name }}
      </h1>
      <ResourcesSlider
        :tag-slug="allQuotes[0].slug"
        :category-index="i"
        :items="allQuotes[0].resources"
      />
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ResourcesSlider from '@/components/ResourcesPage/PlaybackResources/ResourcesSlider.vue';
import FilterResultSection from '@/components/ResourcesPage/PlaybackResources/FilterResultSection.vue';
import { isGPCRPage, isGICPage } from '@/utils/conference-type';

export default {
  components: {
    ResourcesSlider,
    FilterResultSection,
  },
  props: {
    showSelectedSessions: {
      type: String,
      default: 'All',
    },
  },
  computed: {
    ...mapState('filter', [
      'allResources',
      'allQuotes',
      'allBooks',
      'isLoading',
      'filteredSessions',
      'filteredTopics',
      'filteredTypes',
      'showFilterResults',
      'showFilterModal',
      'filteredMaterials',
      'filteredResources',
      'filteredQuotes',
      'filteredBooks',
      'assets',
      'filterType',
      'allBookMarkList',
      'allWatchLists',
    ]),
    // sortedList() {
    // const priorityOrder = ['Watch List', 'My List'];

    //   // Separate priority items and the rest
    //   const priorityItems = [];
    //   const otherItems = [];

    //   this.allResources.forEach(item => {
    //     if (priorityOrder.includes(item.name)) {
    //       priorityItems[priorityOrder.indexOf(item.name)] = item;
    //     } else {
    //       otherItems.push(item);
    //     }
    //   });

    //   // Filter out undefined in case any priority items are missing
    //   return priorityItems.filter(Boolean).concat(otherItems);
    // },
    myList() {
      return this.allBookMarkList !== 'undefined' &&
        this.allBookMarkList &&
        this.allBookMarkList.length > 0
        ? this.allBookMarkList[0]
        : {};
    },
    sortedList() {
      // const myList = this.allBookMarkList.find(item => item.name === "My List");

      const remainingResources = this.allResources.filter(item => item.name !== 'Watch List');

      // Combine with priority order
      const result = [];

      // if (myList && myList.resources.length > 0) {
      //   result.push(myList);
      // }

      // Add remaining items that are not "Watch List" or "My List"
      result.push(...remainingResources);

      return result;
    },
    bookUrl() {
      if (this.allBooks) {
        return this.allBooks[0].resources[0].resourceTranslations[0].resourceUrl;
      }
      return '';
    },
  },
  methods: {
    isGPCRPage() {
      return isGPCRPage();
    },
    isGICPage() {
      return isGICPage();
    },
  },
};
</script>

<style scoped>
.bookmark-hint-icon {
  background-color: currentColor;
  -webkit-mask-image: var(--bookmark-icon);
  mask-image: var(--bookmark-icon);
  -webkit-mask-position: center;
  mask-position: center;
  -webkit-mask-repeat: no-repeat;
  mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  mask-size: contain;
}
</style>
